import React from 'react';

import {
  useRecordContext,
  useCreatePath,
} from 'react-admin';

import {
  IconButton,
  Tooltip,
} from '@mui/material';

import { Launch } from '@mui/icons-material';

import { Link } from 'react-router-dom';

import { KnownEntityTypes, resourceFromEntityTypes } from '../../constants/entityTypes';

const ShowEntityButton = ({
  label,
}: {
  label: string;
}) => {
  const createPath = useCreatePath();
  const record = useRecordContext<{
    id: string;
    type: KnownEntityTypes;
  }>();
  if (!record) return null;

  const path = createPath({
    type: 'edit',
    resource:
    resourceFromEntityTypes[record.type],
    id: record.id,
  });

  return (
    <Tooltip title={label}>
      <IconButton
        aria-label={label}
        size="small"
        color="primary"
        to={path}
        component={Link}
      >
        <Launch />
      </IconButton>
    </Tooltip>
  );
};

export default ShowEntityButton;
